import React, {useState, useContext,useEffect, useLayoutEffect } from 'react';
import { Row, Col,Container } from 'react-bootstrap' ;
import {ControlTemplatesJson,ControlTemplateCategories} from '../DesignerControls/ControlEntries'
import Button from '@material-ui/core/Button'
import style from '../DesignerControls/ControlsNewLayout.module.css'
import CollapsibleComponent from '../../../ReusableComponents/CollapseCard/CollapseCard';
import { sendRequestForPageTemplate } from '../../IFormDesignerLayout/RequestLogic';
// import AppViewer from '../../AppViewer/AppViewer';
import SimpleLoader from '../../../UI/General/SimpleLoader';
import CircularProgress from "@material-ui/core/CircularProgress";
import Zoom from '@material-ui/core/Zoom';
import { AppContext } from '../../../Resources/CanvasContextFile';
import axios from '../../../axios'
import { template } from 'suneditor/src/plugins';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { GetStateFromData } from '../../CustomHooks/CustomHooks';

export default function ControlTemplate(props) {
  
  const AppContextVar = useContext(AppContext);
  var setFormState ;
  if(AppContextVar!==undefined){
      setFormState = AppContextVar.setFormState;
  }
  const { t } = useTranslation(['styles', 'translation']);
  const contexts = GetStateFromData(props.containerId);
const {
    updateJson,
    elementToCreate,
    selectedControl,
    targetElemState,
    changeSectionLayout,
    setOpenProperties,
    formState2,
    setFormState2,
    microFrontendData,
    showAlertConfirmNotifications,
    device
  } = contexts.contexts;
  var selectedTemplateDetails;
  const [open, setOpen] = React.useState(true);
  const [showLoader, setShowLoader] = React.useState(false);
  const [templateForm, setTemplateForm] = React.useState({ });
  const [nonDraggableElements , setNonDraggableElements ] = useState([]);
  const [templateType, setTemplateType] = React.useState('System defined');
  const [selectedTemplateOption, setSelectedTemplateOption] = React.useState();
  const allowedTemplateCategory = ['HEADER','FOOTER','BODY','CONTROL'] ;
  const allowedTemplateCategoryForSystemDefined = ['HEADER','FOOTER','BODY'] ;
  const allowedTemplateCategoryForUserDefined = ['CONTROL'] ;
  const TemplatesHeading = {'HEADER' : 'Header Templates','FOOTER' : 'Footer Templates','BODY' : 'Body Templates'} ;
  var systemDefinedTemplateDetailsObj = {"HEADER" : [], "FOOTER" : [], "BODY" : [] } ;
  var userDefinedTemplateDetailsObj = {"CONTROL" : []} ;
  const [templates, setTemplates] = React.useState({'System defined' : systemDefinedTemplateDetailsObj, 'User defined' : userDefinedTemplateDetailsObj});
  const [templatesUser, setTemplatesUser] = React.useState({'System defined' : systemDefinedTemplateDetailsObj, 'User defined' : userDefinedTemplateDetailsObj});

    useEffect(() => {
        getTemplateByCategory();
    }, [templateType])

  const getTemplateByCategory = async() => {
    // var templateType = 'SYSTEM DEFINED' ;
    window.loading(true)
        var remainingURL = "/templates/type/" + templateType;
        if(templateType === "System defined"){
            try{
                const res1 = await axios.get(`${remainingURL}/HEADER`, { withCredentials: true })
                if (res1 && res1.data && res1.status === 200){
                    res1.data.map((templateDetails)=>{
                    if(allowedTemplateCategory.includes(templateDetails.templatecategory)){
                    if(templateDetails.templatetype === "SYSTEM DEFINED"){
                        systemDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    if(templateDetails.templatetype === "USER DEFINED"){
                        userDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    }
                })
                }
                }
            catch(e){
                console.log(e)
            }

            try{
                const res2 = await axios.get(`${remainingURL}/BODY`, { withCredentials: true })
                if (res2 && res2.data && res2.status === 200){
                    res2.data.map((templateDetails)=>{
                    if(allowedTemplateCategory.includes(templateDetails.templatecategory)){
                    if(templateDetails.templatetype === "SYSTEM DEFINED"){
                        systemDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    if(templateDetails.templatetype === "USER DEFINED"){
                        userDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    }
                })
                }
                }
            catch(e){
                console.log(e)
            }

            try{
                const res3 = await axios.get(`${remainingURL}/FOOTER`, { withCredentials: true })
                if (res3 && res3.data && res3.status === 200){
                    res3.data.map((templateDetails)=>{
                    if(allowedTemplateCategory.includes(templateDetails.templatecategory)){
                    if(templateDetails.templatetype === "SYSTEM DEFINED"){
                        systemDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    if(templateDetails.templatetype === "USER DEFINED"){
                        userDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    }
                })
                }
                }
            catch(e){
                console.log(e)
            }
        }

        else{
            try{
                const res4 = await axios.get(`${remainingURL}/CONTROL`, { withCredentials: true })
                if (res4 && res4.data && res4.status === 200){
                    res4.data.map((templateDetails)=>{
                    if(allowedTemplateCategory.includes(templateDetails.templatecategory)){
                    if(templateDetails.templatetype === "SYSTEM DEFINED"){
                        systemDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    if(templateDetails.templatetype === "USER DEFINED"){
                        userDefinedTemplateDetailsObj[templateDetails.templatecategory].push(templateDetails)
                    }
                    }
                })
                }
                }
            catch(e){
                console.log(e)
            }
        }
        if(templateType === "System defined"){
        setTemplates({ ...templates, 'System defined' : systemDefinedTemplateDetailsObj, 'User defined' : userDefinedTemplateDetailsObj}) ;
        } else {
            setTemplatesUser({ ...templatesUser, 'System defined' : systemDefinedTemplateDetailsObj, 'User defined' : userDefinedTemplateDetailsObj}) ;
        }
        window.loading(false)
  }

  const handleOndragStart = (e,control) => {
    // e.preventDefault();
    // e.stopPropagation();
    axios.get(`templates/${control.templateid}`,{withCredentials:true})
        .then(res =>{
            selectedTemplateDetails = res.data;
            var headerJsonNew;
            const headerJson = JSON.parse(res.data.templatebuffer)
            if(headerJson){
                if(headerJson.children){
                    if(res?.data?.templatetype === "USER DEFINED"){
                        if(headerJson.children[0]){
                            headerJsonNew = headerJson
                        }
                    }
                    else{
                        if(headerJson.children[1]){
                            headerJsonNew = headerJson.children[1]
                        }
                    }
                }
            }
            elementToCreate(e, 'section', headerJsonNew)
        })
    }

//   const handleDrop = (e)  => {
//     console.log("Template Data drop", selectedTemplateDetails)
//     // e.preventDefault();
//     // e.stopPropagation();
    
//   }

  function handleTemplate(){
    setFormState(templateForm);
    setOpen(false);
  }
  function handlePageBasicDetails(){  }
  function handlePageTemplate(templateType, templateSubType, templateFormName){
    setShowLoader(true);
    var jsonToSend = {'templateName' : templateFormName}; 
    sendRequestForPageTemplate(jsonToSend).then((response)=>{
        // console.log(response);
        if(response.status === 200){
          setTemplateForm(response.data);
          setSelectedTemplateOption(templateSubType);
          setShowLoader(false);
        }
    })
  }
  function x(action,dir){   
    
  }
  
function createTemplateOption(key) {
  
}
  
        let openDrawer =false;
        let setOpenDrawer ;
        let drawerPinned =false;
        // let setDrawerPinned;
        if(AppContextVar){
            openDrawer = AppContextVar.openDrawer;
            setOpenDrawer = AppContextVar.setOpenDrawer;
            drawerPinned = AppContextVar.drawerPinned;
            // setDrawerPinned = AppContextVar.setDrawerPinned;
        }

        function closeDrawerWhileDraggingAndNotPinned(){
            if(drawerPinned===false){
                if(openDrawer===true){
                    //console.log(':: openDrawer :: ',openDrawer);
                    setOpenDrawer(false);
                }
            }
        }

        useLayoutEffect(() => {
            var allControlDivWrappers = document.getElementsByClassName("getThisControlDivWrapper");
            for(let i=0;i<allControlDivWrappers.length ; i++){
                ////console.log('allControlDivWrappers['+i+'].childNodes :: ',allControlDivWrappers[i].childNodes);
                if(allControlDivWrappers[i].childNodes[1]){
                    let controlIconWrapper = allControlDivWrappers[i].childNodes[0];
                    var controlIcon;
                    if(controlIconWrapper && controlIconWrapper.childNodes[0]){
                        controlIcon = controlIconWrapper && controlIconWrapper.childNodes[0];
                    }
                    let controlNameDiv = allControlDivWrappers[i].childNodes[1];
                    if(controlNameDiv.childNodes[0]){
                        let controlNameLabel = controlNameDiv.childNodes[0];
                        if(controlNameLabel.innerHTML){
                            var controlNameLength = controlNameLabel.innerHTML.length;
                            if(controlNameLength>11){
                                ////console.log('controlIcon :: ',controlIcon);
                                controlIcon.style.marginBottom = "2px";
                            }
                        }
                    }
                }
            }
            
        });

        // console.log(templates[templateType]);
return (
    <div className={`${style.allControlsWrapper} allControlsWrapperTemplates`}>
        <Col className={style.definingOptionCol} style={{textAlign:"center"}}>
            <span tabIndex={0} style={{height:"auto"}} className={templateType === 'System defined' ? style.definedText  + ' ' + style.selectedDefinedText : 
            style.definedText} onClick={()=>setTemplateType('System defined')}>
                {t(`translation:${"System defined"}`)}</span>
            <span tabIndex={0} style={{height:"auto"}} className={templateType === 'User defined' ? style.definedText  + ' ' +  style.selectedDefinedText :
                style.definedText} onClick={()=>setTemplateType('User defined')}>
                {t(`translation:${"User defined"}`)}</span>
        </Col>
        {
            templateType === "System defined" ?
            allowedTemplateCategoryForSystemDefined.map(
                (categoryName , index) => {
                    return (
                        <div className={style.categoryWrapper}>
                            <Container fluid>
                            <div className={style.categorylabel} style={{display : templateType === "System defined" ? "block" : "none"}}>
                                {t(`translation:${TemplatesHeading[categoryName]}`)}
                            </div>
                            <Row xs={1} md={1} lg={1} className={style.controlGroupWrapper}>
                                {
                                    templates && templates[templateType] && templates[templateType][categoryName] ?
                                    templates[templateType][categoryName].map(
                                        control => {
                                            // var controlIcon = control['templatename'];
                                            var controlIcon = control['templateimage'];
                                            var controlLabel = control['templatename'];
                                            var controlElemType = control['elem_type'];
                                            
                                            if(nonDraggableElements.includes(controlElemType)){
                                                return (
                                                    <Zoom in={true}>
                                                        <Col className={style.nonDraggableElement}  inptype={controlElemType} 
                                                        // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                        // onDragStart={props.createNewElement} 
                                                        draggable="false">
                                                            <div className={style.ControlsWrapperNonDraggable + ' getThisControlDivWrapper'} 
                                                            inptype={controlElemType} 
                                                            // onDragStart={props.createNewElement} draggable="true" 
                                                            // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                            >
                                                                <div className={style.IconWrapper}>
                                                                    {controlIcon? <div className={style.templateIconDiv} >{controlIcon}</div> : <div className={style.squareIcon} />}
                                                                </div>
                                                                <div className={style.controlName + ' controlNameDiv'}>
                                                                    {/* <div className={style.controlLabel+' controlNameLabel'}>
                                                                        {controlLabel}

                                                                    </div> */}
                                                                </div>

                                                            </div>
                                                        </Col>
                                                    </Zoom>
                                                );
                                            } else {
                                                return (
                                                    <Zoom in={true}>
                                                        <Col className={style.customCol}  inptype={controlElemType} 
                                                        onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                        onDragStart={(e) => handleOndragStart(e, control)}
                                                        tabIndex={0}
                                                        draggable="true">
                                                            <div className={style.ControlsTemplateWrapper + ' getThisControlDivWrapper'} 
                                                            onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                            onDragStart={(e) => handleOndragStart(e, control)}
                                                            // onTouchStart={props.createNewElement} 
                                                            draggable="true" 
                                                            inptype={controlElemType} 
                                                            >
                                                                <>
                                                                {controlIcon 
                                                                ? 
                                                                <div className={style.templateIconDiv} >
                                                                    <img inptype={controlElemType} onDrag={closeDrawerWhileDraggingAndNotPinned} onDragStart={(e) => handleOndragStart(e, control)} src={controlIcon} style={{width: "100%", height:"50px", opacity:"1", padding:"5px", zoom:"100%"}}
                                                                    alt='Drag Icon'/>
                                                                </div>
                                                                 : 
                                                                 <div className={style.squareIcon} />}
                                                                </>
                                                                {/* <div className={style.controlName + ' controlNameDiv'}>
                                                                    <div className={style.controlLabel+' controlNameLabel'}>
                                                                        {controlLabel}

                                                                    </div>
                                                                </div> */}

                                                            </div>
                                                        </Col>
                                                    </Zoom>
                                                )
                                            }   
                                        }                                                    
                                    )
                                    :
                                    <Col className={style.customCol}  >
                                        <div className={style.ControlsTemplateWrapper + ' getThisControlDivWrapper'} >
                                            <CircularProgress  />
                                        </div>
                                    </Col>
                                }

                            </Row>
                            </Container>
                            
                        </div>
                    );
                    
                }
            )
            :
            templatesUser?.[templateType]?.['CONTROL']?.length === 0 ?         
                        <div className={style.categoryWrapper}>
                        <Container fluid>
                        <div style={{display : "flex",justifyContent: "center"}}>
                        {t(`translation:${"NO_USER_DEFINED_TEMPLATES"}`)}
                        </div>
                        </Container>
                        </div> 
                :
                allowedTemplateCategoryForUserDefined.map(
                (categoryName , index) => {
                    return (
                        <div className={style.categoryWrapper}>
                            <Container fluid>
                            <div className={style.categorylabel} style={{display : templateType === "System defined" ? "block" : "none"}}>
                            {t(`translation:${TemplatesHeading[categoryName]}`)}
                            </div>
                            <Row xs={1} md={1} lg={1} className={style.controlGroupWrapper}>
                                {
                                    templatesUser && templatesUser[templateType] && templatesUser[templateType][categoryName] ?
                                    templatesUser[templateType][categoryName].map(
                                        control => {
                                            // var controlIcon = control['templatename'];
                                            var controlIcon = control['templateimage'];
                                            var controlLabel = control['templatename'];
                                            var controlElemType = control['elem_type'];
                                            
                                            if(nonDraggableElements.includes(controlElemType)){
                                                return (
                                                    <Zoom in={true}>
                                                        <Col className={style.nonDraggableElement}  inptype={controlElemType} 
                                                        // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                        // onDragStart={props.createNewElement} 
                                                        draggable="false">
                                                            <div className={style.ControlsWrapperNonDraggable + ' getThisControlDivWrapper'} 
                                                            inptype={controlElemType} 
                                                            // onDragStart={props.createNewElement} draggable="true" 
                                                            // onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                            >
                                                                <div className={style.IconWrapper}>
                                                                    {controlIcon? <div className={style.templateIconDiv} >{controlIcon}</div> : <div className={style.squareIcon} />}
                                                                </div>
                                                                <div className={style.controlName + ' controlNameDiv'}>
                                                                    {/* <div className={style.controlLabel+' controlNameLabel'}>
                                                                        {controlLabel}

                                                                    </div> */}
                                                                </div>

                                                            </div>
                                                        </Col>
                                                    </Zoom>
                                                );
                                            } else {
                                                return (
                                                    <Zoom in={true}>
                                                        <Col tabIndex={0} className={style.customCol}  inptype={controlElemType} onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                        onDragStart={props.createNewElement} 
                                                        draggable="true"  title={controlLabel}>
                                                            <div className={style.ControlsTemplateWrapper + ' getThisControlDivWrapper'} 
                                                            onDragStart={props.createNewElement} draggable="true" inptype={controlElemType} 
                                                            onDrag={closeDrawerWhileDraggingAndNotPinned} 
                                                            >
                                                                <>
                                                                {controlIcon 
                                                                ? 
                                                                <div className={style.templateIconDiv} >
                                                                    <img inptype={controlElemType} onDragStart={(e) => handleOndragStart(e, control)}  src={controlIcon} style={{width: "100%", height:"50px", opacity:"1", padding:"5px", zoom:"100%"}}
                                                                    alt='Template Icon'/>
                                                                </div>
                                                                 : 
                                                                 <div draggable="true" inptype={controlElemType} className={style.squareIcon} onDragStart={(e) =>{handleOndragStart(e, control)}} />}
                                                                </>
                                                             
                                                              
                                                               

                                                            </div>
                                                            <div className={style.controlName + ' controlNameDiv'}>
                                                                    <div className={[style.controlLabel+' controlNameLabel',style.categorylabel].join(" ")} style={{maxWidth:'48%',whiteSpace:'nowrap'}}>
                                                                       <span>{controlLabel}</span> 

                                                                    </div>
                                                                </div>
                                                        </Col>
                                                    </Zoom>
                                                )
                                            }   
                                        }                                                    
                                    )
                                    :
                                    <Col className={style.customCol}  >
                                        <div className={style.ControlsTemplateWrapper + ' getThisControlDivWrapper'} >
                                            <CircularProgress  />
                                        </div>
                                    </Col>
                                }

                            </Row>
                            </Container>
                            
                        </div>
                    );
                    
                }
            )
        }


    </div>
    )
}